$(document).ready(function()
{
    // change the contents of a standard modal on clock, for image zooms
    $('.zoom-in-image, .zoom-in-background').click(function(e)
    {
        e.preventDefault();
        if ( $('#defaultZoomModal').length )
        {

            var useImg = $(this).find("img").data('zoom-size');
            var useAlt = $(this).find("img").attr('alt');
            var useCaption = $(this).find("figcaption").html();

            var hasCaption = (useCaption !== undefined && useCaption != '') ? true : false;


            if (useImg)
            {

                $('#defaultZoomModalImage').attr('src', useImg);
                $('#defaultZoomModalImage').attr('alt', useAlt);     
                $('#defaultZoomModalTitle').html(useAlt);

                if (hasCaption)
                {
                    $('#defaultZoomModalFig').addClass("active");
                    $('#defaultZoomModalFig').html(useCaption);
                }
                else
                {
                    $('#defaultZoomModalFig').removeClass("active");
                    $('#defaultZoomModalFig').html("");
                }

                setTimeout(function () 
                {
                    $('#defaultZoomModal').foundation('open');
                }, 100);
            }

        }

    });

    $( '.close-reveal-modal').click(function () {
        var id = $( this ).parents( '.reveal').first().attr( 'id');
        $( '#' + id ).foundation('close');
    });

});